import { action, makeObservable, observable } from "mobx";
import { IRootStore } from "src/Shared/Stores/Root.store";
import { finalize } from "rxjs";
import CompanyRevenueService from "../Services/CompanyRevenue.service";
import { ICompanyRevenue } from "../Interfaces/ICompanyRevenue";
import DateTimeUtils from "src/Shared/Tools/DateTimeUtils";

export class CompanyRevenueStore {
  rootStore: IRootStore;
  public gridLoading: boolean = false;
  public companyRevenueData: ICompanyRevenue[] = [];

  constructor(rootStore: IRootStore) {
    makeObservable(this, {
      gridLoading: observable,
      companyRevenueData: observable,
      setCompanyRevenueData: action,
      getCompanyRevenue: action,
    });
    this.rootStore = rootStore;
  }

  setGridLoading = (flag: boolean): void => {
    this.gridLoading = flag;
  };

  getCompanyRevenue = (companyRowID: string) => {
    this.setGridLoading(true);
    return CompanyRevenueService.getCompanyRevenue(companyRowID)
      .pipe(
        finalize(() => {
          this.setGridLoading(false);
        })
      )
      .subscribe((data) => {
        this.setCompanyRevenueData(data);
      });
  };

  setCompanyRevenueData = (data: ICompanyRevenue[]) => {
    data = data.map((x) => {
      if (x.companyAdditionalRevenueStream != null) {
        x.companyAdditionalRevenueStream.createdOn =
          DateTimeUtils.dateToLocalTimeZone(
            x.companyAdditionalRevenueStream.createdOn
          );
        x.companyAdditionalRevenueStream.updatedOn =
          DateTimeUtils.dateToLocalTimeZone(
            x.companyAdditionalRevenueStream.createdOn
          );
        x.companyAdditionalRevenueStream.date =
          DateTimeUtils.dateToLocalDateZone(
            x.companyAdditionalRevenueStream.date
          );
      }
      return x;
    });
    this.companyRevenueData = data;
  };
}
